import { render } from "./RoleList.vue?vue&type=template&id=653fbb0e&scoped=true"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"

import "./RoleList.vue?vue&type=style&index=0&id=653fbb0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653fbb0e"]])

export default __exports__